import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
   Input, Button, Select, Row, Col,
   Modal, DatePicker, Upload, Form, Spin, Tree, InputNumber, Typography, Switch
} from 'antd';
import * as AntDIcons from '@ant-design/icons';
import SimpleBarReact from "simplebar-react";
import axios from 'axios';
// import uuid from 'react-uuid';
// import { SchoolTerms, Levels } from '../../../constants'
import Utils from '../../../misc/Utils';
import Enums from '../../../misc/Enums';
// import { Editor } from '@tinymce/tinymce-react';
import StickyBox from "react-sticky-box";
import moment from 'moment';
import Wysiwyg2 from '../../../components/wysiwyg/wysiwyg2';
import WysiwygMathEditor from '../../../components/wysiwyg/WysiwygMathEditor';
import DocumentViewer from '../../../components/document-viewer/DocumentViewer';
import { allowed_levels_in_microcredentials } from '../../../constants';
import { getCourses, getTopicsByCourse } from '../../../services/MicrocredentialsCourseTopicService';
import { buildMicrocredentialSubjectCode, getMicrocredentialCourseId, getMicrocredentialCourseName, getMicrocredentialSubjectIdValue, getMicrocredentialTopicId, getMicrocredentialTopicName, parseMicrocredentialSubjectCode } from '../microcredentialUtils';
import { isPlagiarismCheckerEnabled, isPlagiarismEligibleLevel } from '../plagiarismUtils';

const { Text } = Typography;

export default function Edit(props) {
   const [form] = Form.useForm();
   const editorRef = useRef(null);
   const navigate = useNavigate();

   const [levelList, setLevelList] = useState([]);
   const [secsubLoading, setSecSubLoading] = useState(false);
   const [title, setTitle] = useState("");
   const [level, setLevel] = useState(null);
   const [section, setSection] = useState([]);
   const [subject, setSubject] = useState(null);
   const [description, setDescription] = useState(null);
   const [uploadFileList, setUploadFileList] = useState([]);
   const [subjectList, setSubjectList] = useState([]);
   const [sectionList, setSectionList] = useState([]);
   const [homeworkDate, setHomeworkDate] = useState('');
   const [submissionDate, setSubmissionDate] = useState('');
   const [homeworkData, setHomeworkData] = useState(null);
   const [previewDocument, setPreviewDocument] = useState(null);
   const [previewDocumentName, setPreviewDocumentName] = useState(null);
   const [previewModalVisible, setPreviewModalVisible] = useState(false);
   const [subdomain, setSubdomain] = useState(localStorage.getItem("lms-subdomain"));
   const [maxScore, setMaxScore] = useState(null);
   const [topic, setTopic] = useState(null);
   const [topicList, setTopicList] = useState([]);
   const [coursesLoading, setCoursesLoading] = useState(false);
   const [topicsLoading, setTopicsLoading] = useState(false);

   const [checkedKeys, setCheckedKeys] = useState([]);
   const [selectedKeys, setSelectedKeys] = useState([]);
   const [treeData, setTreeData] = useState([]);
   const [expandedKeys, setExpandedKeys] = useState([]);
   const [assignedStudents, setAssignedStudents] = useState(null);
   const [assignedStudentsWithSection, setAssignedStudentsWithSection] = useState(null);

   const { Option } = Select;

   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);
   const isMicrocredentialType = props.type === 'microcredential';

   const dateFormat = 'MMM D, YYYY h:mm a';
   const customFormat = value => `${value.format(dateFormat)}`;

   useEffect(() => {
      Utils.verifyJwt();

      // if (user_role.toLowerCase() !== 'admin' && user_role.toLowerCase() !== 'teacher' && user_role.toLowerCase() !== 'co-teacher')
      const allowedRoles = ['super admin', 'admin', 'teacher', 'co-teacher'];
      if (!allowedRoles.includes(user_role.toLowerCase()))
         navigate('/home');

      getLevels();
      // getHomeworkInfo(props.homeworkID);
   }, [props.homeworkID]);

   useEffect(() => {
      return () => {
         if (previewDocument && previewDocument.startsWith('blob:'))
            URL.revokeObjectURL(previewDocument);
      }
   }, [previewDocument]);

   const loadStudentTree = (levelValue, assignedStudentKeys = []) => {
      axios.get(`${process.env.REACT_APP_API_ASSESSMENT}/studentlistperleveljson?level=${levelValue}`).then((response) => {
         if (response.data) {
            const data = response.data;
            setTreeData(data);
            setCheckedKeys(assignedStudentKeys);
         }
      }, (error) => {
         console.log(error.message);
      });
   };

   const loadMicrocredentialCourses = async () => {
      try {
         setCoursesLoading(true);
         const data = await getCourses();
         const courses = (Array.isArray(data) ? data : []).map((course) => ({
            value: getMicrocredentialCourseId(course),
            name: getMicrocredentialCourseName(course),
         })).filter((course) => course.value !== null && course.name);

         setSubjectList(courses);
         return courses;
      } catch (error) {
         Modal.error({
            title: 'Homework',
            content: 'Failed to load courses',
            centered: true,
         });
         setSubjectList([]);
         return [];
      } finally {
         setCoursesLoading(false);
      }
   };

   const loadMicrocredentialTopics = async (courseId) => {
      if (!courseId) {
         setTopicList([]);
         return [];
      }

      try {
         setTopicsLoading(true);
         const data = await getTopicsByCourse(courseId);
         const topics = (Array.isArray(data) ? data : []).map((topicItem) => ({
            value: getMicrocredentialTopicId(topicItem),
            name: getMicrocredentialTopicName(topicItem),
         })).filter((topicItem) => topicItem.value !== null && topicItem.name);

         setTopicList(topics);
         return topics;
      } catch (error) {
         Modal.error({
            title: 'Homework',
            content: 'Failed to load topics',
            centered: true,
         });
         setTopicList([]);
         return [];
      } finally {
         setTopicsLoading(false);
      }
   };

   const getMatchingOptionValue = (options, targetValue) => {
      if (targetValue === null || targetValue === undefined) return null;

      const matchedOption = options.find(({ value }) => String(value) === String(targetValue));
      return matchedOption ? matchedOption.value : targetValue;
   };

   const resolveStoredDocumentUrl = (storedPath) => {
      const raw = String(storedPath || '').trim();
      if (!raw) return null;
      if (/^(https?:)?\/\//i.test(raw) || /^(data|blob):/i.test(raw)) return raw;
      if (raw.startsWith('/')) return `${process.env.REACT_APP_API_S3_URL}${raw}`;
      if (subdomain && raw.startsWith(`${subdomain}/`)) return `${process.env.REACT_APP_API_S3_URL}/${raw}`;

      return `${process.env.REACT_APP_API_S3_URL}/${subdomain}/${process.env.REACT_APP_S3_HOMEWORKS_TEACHERS_PATH}/${raw}`;
   };

   const parseExistingDocuments = (documentValue) => {
      if (!documentValue) return [];

      return String(documentValue)
         .split(',')
         .map((item) => item.trim())
         .filter(Boolean)
         .map((item, index) => ({
            uid: `existing-${index}`,
            name: item.split('/').pop() || item,
            status: 'done',
            url: resolveStoredDocumentUrl(item),
            isExisting: true,
            storedValue: item,
         }));
   };

   const getLevels = () => {
      axios.get(`${process.env.REACT_APP_API_LOOKUP}/levellist`).then((response) => {
         if (response.data) {
            const data = response.data;
            const processedLevels = data.map(item => ({ 
               value: item.value, 
               name: item.name 
            })).filter(item => {
               if (!isMicrocredentialType) return true;

               const val = String(item.value ?? '').trim();
               const label = String(item.name ?? '').toLowerCase();
                 
               return allowed_levels_in_microcredentials.some(lvl => val === lvl || label.includes(lvl));
            });

            setLevelList(processedLevels);

            if (isMicrocredentialType) {
               loadMicrocredentialCourses().finally(() => getHomeworkInfo(props.homeworkID));
            } else {
               getHomeworkInfo(props.homeworkID);
            }
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const getHomeworkInfo = async (id) => {
      axios.get(`${process.env.REACT_APP_API_HOMEWORK}/info?id=${id}`).then(async (response) => {
         if (response.data) {
            const homeworkdata = response.data[0];
            const assignedStudentKeys = String(homeworkdata.assigned_students || '').split(',').filter(Boolean);

            setExpandedKeys([]);
            setTitle(homeworkdata.title);
            setLevel(homeworkdata.class_id);
            setHomeworkDate(homeworkdata.homework_date);
            setSubmissionDate(homeworkdata.submit_date);
            setDescription(homeworkdata.description);
            setUploadFileList(parseExistingDocuments(homeworkdata.document));
            setAssignedStudents(homeworkdata.students);
            setAssignedStudentsWithSection(homeworkdata.assigned_students);
            setMaxScore(homeworkdata.max_points);
            setHomeworkData(homeworkdata);
            form.setFieldsValue({
               plagiarism_checker: isPlagiarismCheckerEnabled(homeworkdata.plagiarism_checker),
            });

            if (isMicrocredentialType) {
               const metadata = parseMicrocredentialSubjectCode(homeworkdata.subject_code);
               const savedCourseId = metadata?.course_id ?? null;
               const courseOptions = subjectList.length > 0 ? subjectList : await loadMicrocredentialCourses();
               const courseId = getMatchingOptionValue(courseOptions, savedCourseId);
               const topicOptions = courseId ? await loadMicrocredentialTopics(courseId) : [];
               const topicId = getMatchingOptionValue(topicOptions, metadata?.topic_id ?? null);

               setSubject(courseId);
               setTopic(topicId);

               if (!courseId) {
                  setTopicList([]);
               }

               form.setFieldsValue({
                  title: homeworkdata.title,
                  level: homeworkdata.class_id,
                  subject: courseId ?? undefined,
                  course_topic: topicId ?? undefined,
                  max_score: homeworkdata.max_points,
                  homework_date: moment(homeworkdata.homework_date),
                  submission_date: moment(homeworkdata.submit_date),
               });
            } else {
               axios.get(`${process.env.REACT_APP_API_LOOKUP}/subjectlist?level=${homeworkdata.class_id}&school_year=16`).then((subjectResponse) => {
                  if (subjectResponse.data) {
                     const subjectOptions = subjectResponse.data.map((item) => ({ value: item.value, name: item.name }));
                     const subjectId = getMatchingOptionValue(subjectOptions, homeworkdata.subject_id);

                     setSubjectList(subjectOptions);
                     setSubject(subjectId);
                     form.setFieldsValue({
                        title: homeworkdata.title,
                        level: homeworkdata.class_id,
                        subject: subjectId ?? undefined,
                        max_score: homeworkdata.max_points,
                        homework_date: moment(homeworkdata.homework_date),
                        submission_date: moment(homeworkdata.submit_date),
                     });
                  }
               }, (error) => {
                  console.log(error.message);
               });
            }

            loadStudentTree(homeworkdata.class_id, assignedStudentKeys);
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const upload_props = {
      fileList: uploadFileList,
      onRemove: file => {
         if (previewDocumentName === file.name)
            handleClosePreview();

         setUploadFileList((currentFiles) => currentFiles.filter((item) => item.uid !== file.uid));
      },

      beforeUpload: file => {
         const isPNG = file.type === 'image/png';
         const isJPG = file.type === 'image/jpeg';
         const isBMP = file.type === 'image/bmp';
         const isDOC = file.type === 'application/msword' || file.type === 'application/vnd.msword';
         const isDOCX = file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
         const isXLS = file.type === 'application/msexcel' || file.type === 'application/vnd.msexcel';
         const isXLSX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
         const isPPT = file.type === 'application/vnd.ms-powerpoint';
         const isPPTX = file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
         const isPPSX = file.type === 'application/vnd.openxmlformats-officedocument.presentationml.slideshow';
         const isPDF = file.type === 'application/pdf';

         const fileValid = isPNG || isJPG || isBMP || isDOC || isDOCX || isXLS || isXLSX || isPPT || isPPTX || isPDF || isPPSX;

         const allowedFileSize = 100;
         const maxAttachments = 3;

         if (fileValid) {
            const isLtMB = file.size / 1024 / 1024 <= allowedFileSize;

            if (!isLtMB) {
               Modal.error({
                  title: 'Homework',
                  content: `Maximum allowed file size is ${allowedFileSize} MB`,
                  centered: true
               });
               return Upload.LIST_IGNORE;
            }

            if (uploadFileList.length >= maxAttachments) {
               Modal.error({
                  title: 'Homework',
                  content: `You can only upload up to ${maxAttachments} files.`,
                  centered: true
               });
               return Upload.LIST_IGNORE;
            }

            setUploadFileList((currentFiles) => [...currentFiles, file]);
         } else {
            Modal.error({
               title: 'Homework',
               content: 'You are not allowed to upload that file type',
               centered: true
            });
            return Upload.LIST_IGNORE;
         }

         return false;
      },

      onPreview: file => {
         handlePreviewAttached(file);
      },
      showUploadList: {
         showPreviewIcon: true,
         showRemoveIcon: true,
      },
   };

   const handleLevelCreateChange = (val) => {
      setSection([]);
      setSubject(null);
      setTopic(null);
      setTopicList([]);
      setLevel(val);
      if (!isPlagiarismEligibleLevel(val, levelList))
         form.setFieldsValue({ plagiarism_checker: false });
      setSecSubLoading(true);

      if (isMicrocredentialType) {
         loadStudentTree(val, []);
         setSecSubLoading(false);
         return;
      }

      axios.get(`${process.env.REACT_APP_API_LOOKUP}/subjectlist?level=${val}&school_year=16`).then((response) => {
         if (response.data) {
            const subjectOptions = response.data.map((item) => ({ value: item.value, name: item.name }));
            setSubjectList(subjectOptions);
            loadStudentTree(val, []);
            setSecSubLoading(false);
         }
      }, (error) => {
         console.log(error.message);
         setSecSubLoading(false);
      });
   }

   const handleDescriptionChange = (val) => {
      setDescription(val);
   }

   const handleFormValuesChange = (changedValues) => {
      const formFieldName = Object.keys(changedValues)[0];

      if (formFieldName === "level") {
         setLevel(changedValues[formFieldName]);
         form.setFieldsValue({ section: undefined });
         form.setFieldsValue({ subject: undefined });
         setSectionList([]);
         setAssignedStudents([]);
         setAssignedStudentsWithSection([]);
         if (!isPlagiarismEligibleLevel(changedValues[formFieldName], levelList))
            form.setFieldsValue({ plagiarism_checker: false });

         if (isMicrocredentialType) {
            form.setFieldsValue({ course_topic: undefined });
            setTopic(null);
            setTopicList([]);
         } else {
            setSubjectList([]);
         }
      }
   };

   const handleCourseChange = (courseId) => {
      setSubject(courseId);
      setTopic(null);
      form.setFieldsValue({ course_topic: undefined });

      if (courseId) {
         loadMicrocredentialTopics(courseId);
      } else {
         setTopicList([]);
      }
   }

   const handlePreviewAttached = (file) => {
      if (previewDocument && previewDocument.startsWith('blob:'))
         URL.revokeObjectURL(previewDocument);

      if (file?.isExisting) {
         setPreviewDocument(file.url || resolveStoredDocumentUrl(file.storedValue));
         setPreviewDocumentName(file.name || 'Attachment');
         setPreviewModalVisible(true);
         return;
      }

      const sourceFile = file.originFileObj || file;
      const objectUrl = URL.createObjectURL(sourceFile);

      setPreviewDocument(objectUrl);
      setPreviewDocumentName(file.name || sourceFile.name);
      setPreviewModalVisible(true);
   }

   const handleClosePreview = () => {
      setPreviewModalVisible(false);
      setPreviewDocument((currentDocument) => {
         if (currentDocument && currentDocument.startsWith('blob:'))
            URL.revokeObjectURL(currentDocument);

         return null;
      });
      setPreviewDocumentName(null);
   }

   const handleCancelCreate = () => {
      setAssignedStudents([]);
      setAssignedStudentsWithSection([]);
      setUploadFileList([]);
      setSection([]);
      setSubject(null);
      setTopic(null);
      setTopicList([]);
      setLevel(null);
      form.resetFields();
      props.onCancelCallback();
      // var sectns = homeworkData.sections.split(',');
      // var arrayOfNumbers = (homeworkData.sections.split(',')).map(Number);
      // setSection(arrayOfNumbers);
   }

   const onFinish = (values) => {
      const selectedCourseId = values.subject ?? subject;
      const selectedTopicId = values.course_topic ?? topic;
      const selectedCourse = subjectList.find(({ value }) => String(value) === String(selectedCourseId));
      const selectedTopic = topicList.find(({ value }) => String(value) === String(selectedTopicId));
      const subjectId = isMicrocredentialType ? getMicrocredentialSubjectIdValue(selectedCourseId) : selectedCourseId;
      const existingDocuments = uploadFileList
         .filter((file) => file.isExisting)
         .map((file) => file.storedValue || file.name)
         .filter(Boolean);
      const filesForUpload = uploadFileList.filter((file) => !file.isExisting);

      let hwData = {
         id: homeworkData.id,
         class_id: level,
         session_id: 0,
         title: title,
         homework_date: moment(homeworkDate).format('YYYY-MM-DD HH:mm:ss'),
         submit_date: moment(submissionDate).format('YYYY-MM-DD HH:mm:ss'),
         subject_id: subjectId,
         description: description,
         created_by: homeworkData.created_by,
         document: existingDocuments.join(','),
         sections: '',
         assigned_students: assignedStudentsWithSection,
         students: assignedStudents,
         max_points: maxScore,
         type: props.type,
         plagiarism_checker: isPlagiarismEligibleLevel(level, levelList)
            && values.plagiarism_checker === true,
         ...(isMicrocredentialType ? {
            subject_code: buildMicrocredentialSubjectCode({
               courseId: selectedCourseId,
               courseName: selectedCourse?.name ?? '',
               topicId: selectedTopicId,
               topicTitle: selectedTopic?.name ?? '',
            }),
         } : {}),
      }

      props.onFinishCallback(hwData, filesForUpload)
   }

   const onExpand = (expandedKeysValue) => {
      setExpandedKeys(expandedKeysValue);
   };

   const onCheck = (checkedKeysValue) => {
      setCheckedKeys(checkedKeysValue);

      //-- (start) with section ------------------------------
      const selectedStudsWithSection = checkedKeysValue.filter((e) => {
         return e.includes('_');
         //return e.includes('|');
      });

      setAssignedStudentsWithSection(selectedStudsWithSection.length > 0 ? selectedStudsWithSection.join(',') : '');
      //-- (end) with section ------------------------------

      if (selectedStudsWithSection.length > 0) {
         //-- Remove the section part
         for (var i = 0; i < selectedStudsWithSection.length; i++) {
            selectedStudsWithSection[i] = selectedStudsWithSection[i].substring(selectedStudsWithSection[i].indexOf('_') + 1, selectedStudsWithSection[i].length);
            //selectedStudsWithSection[i] = selectedStudsWithSection[i].substring(selectedStudsWithSection[i].indexOf('|') + 1, selectedStudsWithSection[i].length);
         }

         var selected = [...new Set(selectedStudsWithSection)]; //-- Remove duplicate students
         setAssignedStudents(selected.join(','));
      } else {
         setAssignedStudents('');
      }
   };

   const onSelect = (selectedKeysValue, info) => {
      setSelectedKeys(selectedKeysValue);
   };

   const selectedStudentCount = checkedKeys.filter((key) => key.includes('_')).length;
   const plagiarismEligible = isPlagiarismEligibleLevel(level, levelList);
   const workTypeLabel = props.type === "project"
      ? "Project"
      : props.type === "microcredential"
         ? "Microcredential"
         : "Homework";

   return (
      <>
         {homeworkData !== null
            ?
            <Form
               id={props.formId || "homework-assignment-edit-form"}
               className="homework-modal-form"
               form={form}
               layout={"vertical"}
               colon={false}
               onFinish={onFinish}
               onValuesChange={handleFormValuesChange}
            >
               <div className="homework-modal-section">
                  <div className="homework-modal-section-header">
                     <span className="homework-modal-section-icon"><AntDIcons.SettingOutlined /></span>
                     <div>
                        <span className="homework-modal-kicker">Details</span>
                        <h3>{workTypeLabel} Settings</h3>
                     </div>
                  </div>
                  <Row gutter={16}>
                     <Col xs={24}>
                     <Form.Item
                        name="title"
                        label={<Text>Title</Text>}
                        rules={[{
                           required: true,
                           message: 'Title should not be blank'
                        }]}
                        initialValue={title}
                     >
                        <Input
                           allowClear
                           size='middle'
                           style={{ borderRadius: 7 }}
                           placeholder={`Enter ${workTypeLabel.toLowerCase()} title`}
                           onBlur={(event) => setTitle(event.target.value)}
                           value={title}
                        />
                     </Form.Item>
                     </Col>
                  </Row>

                  <Row gutter={16}>
                     <Col xs={24} md={isMicrocredentialType ? 5 : 6} lg={isMicrocredentialType ? 5 : 6}>
                     <Form.Item
                        name="level"
                        label={<Text>Level</Text>}
                        rules={[{
                           required: true,
                           message: 'Please select level'
                        }]}
                        initialValue={level}
                     >
                        <Select
                           showArrow
                           size='middle'
                           style={{ width: '100%' }}
                           allowClear
                           placeholder="Select Level"
                           onChange={(val) => handleLevelCreateChange(val)}
                           value={level}
                        >
                           {levelList.map(({ value, name }) => {
                              return <Option key={`level-${value}`} value={value}>{name}</Option>
                           })}
                        </Select>
                     </Form.Item>
                     </Col>
                     <Col xs={24} md={isMicrocredentialType ? 7 : 12} lg={isMicrocredentialType ? 7 : 12}>
                     <Form.Item
                        name="subject"
                        label={<Text>{isMicrocredentialType ? 'Course' : 'Subject'}</Text>}
                        rules={[{
                           required: true,
                           message: isMicrocredentialType ? 'Please select course' : 'Please select subject'
                        }]}
                        initialValue={subject}
                     >
                        <Select
                           loading={isMicrocredentialType ? coursesLoading : secsubLoading}
                           showArrow
                           size='middle'
                           style={{ width: '100%' }}
                           allowClear
                           placeholder={isMicrocredentialType ? 'Select Course' : 'Select Subject'}
                           value={subject}
                           onChange={(val) => isMicrocredentialType ? handleCourseChange(val) : setSubject(val)}
                           disabled={isMicrocredentialType}
                        >
                           {subjectList.map(({ value, name }) => {
                              return <Option key={`subject-${value}`} value={value}>{name}</Option>
                           })}
                        </Select>
                     </Form.Item>
                     </Col>
                     {isMicrocredentialType && (
                        <Col xs={24} md={7} lg={7}>
                           <Form.Item
                              name="course_topic"
                              label={<Text>Topic</Text>}
                              rules={[{
                                 required: true,
                                 message: 'Please select topic'
                              }]}
                              initialValue={topic}
                           >
                              <Select
                                 loading={topicsLoading}
                                 showArrow
                                 size='middle'
                                 style={{ width: '100%' }}
                                 allowClear
                                 placeholder="Select Topic"
                                 value={topic}
                                 disabled={!subject}
                                 onChange={(val) => setTopic(val)}
                              >
                                 {topicList.map(({ value, name }) => (
                                    <Option key={`topic-${value}`} value={value}>{name}</Option>
                                 ))}
                              </Select>
                           </Form.Item>
                        </Col>
                     )}
                     <Col xs={24} md={isMicrocredentialType ? 5 : 6} lg={isMicrocredentialType ? 5 : 6}>
                     <Form.Item name="max_score" label={<Text>Max Score</Text>}
                        rules={[{
                           required: true,
                           message: 'Please Enter Max Score'
                        }]}
                        initialValue={maxScore}
                     >
                        <InputNumber
                           allowClear
                           min={0}
                           max={100}
                           size='middle'
                           style={{ borderRadius: 7, width: '100%' }}
                           placeholder="Enter max score"
                           onBlur={(event) => setMaxScore(event.target.value)}
                           value={maxScore}
                        />
                     </Form.Item>
                     </Col>
                  </Row>
                  <Row gutter={16} align="top">
                     <Col xs={24} md={8} lg={8}>
                     <Form.Item
                        name="homework_date"
                        label={<Text>{workTypeLabel} Date</Text>}
                        rules={[{
                           required: true,
                           message: `Please enter ${workTypeLabel.toLowerCase()} date`
                        }]}
                        initialValue={moment(homeworkDate)}
                     >
                        <DatePicker
                           size='middle'
                           style={{ width: "100%" }}
                           showTime={{ format: 'hh:mm A', use12Hours: true }}
                           format={customFormat}
                           onBlur={(event) => setHomeworkDate(event.target.value)}
                           value={moment(homeworkDate)}
                        />
                     </Form.Item>
                     </Col>
                     <Col xs={24} md={8} lg={8}>
                     <Form.Item
                        name="submission_date"
                        label={<Text>Submission Date</Text>}
                        rules={[{
                           required: true,
                           message: 'Please enter submission date'
                        }]}
                        initialValue={moment(submissionDate)}
                     >
                        <DatePicker
                           size='middle'
                           style={{ width: "100%" }}
                           showTime={{ format: 'hh:mm A', use12Hours: true }}
                           format={customFormat}
                           onBlur={(event) => setSubmissionDate(event.target.value)}
                           value={moment(submissionDate)}
                        />
                     </Form.Item>
                     </Col>
                     <Col xs={24} md={8} lg={8}>
                           <Form.Item
                              name="plagiarism_checker"
                              label={<Text>Plagiarism Checker</Text>}
                              valuePropName="checked"
                              initialValue={false}
                           >
                              <Switch
                                 disabled={!plagiarismEligible}
                                 checkedChildren="Enabled"
                                 unCheckedChildren="Off"
                              />
                           </Form.Item>
                           {/* <Text type="secondary">
                              {plagiarismEligible
                                 ? 'Enable plagiarism scanning for student file submissions.'
                                 : 'Available only for Grade 9 to Grade 12.'}
                           </Text> */}
                     </Col>
                  </Row>
               </div>

               <Row gutter={16} className="homework-modal-panel-grid">
                  <Col xs={24} md={8} lg={8}>
                     <div className="homework-modal-panel">
                        <div className="homework-modal-section-header">
                           <span className="homework-modal-section-icon"><AntDIcons.UsergroupAddOutlined /></span>
                           <div>
                              <span className="homework-modal-kicker">Recipients</span>
                              <h3>Select Students</h3>
                           </div>
                           <span className="homework-modal-count">{selectedStudentCount}</span>
                        </div>
                        <Form.Item name="select_students" label={<Text>Select Students</Text>} style={{ marginBottom: '5px' }}>
                        <SimpleBarReact className="homework-modal-scroll is-edit">
                           <div className="student-div homework-student-tree">
                              <Tree
                                 checkable
                                 onExpand={onExpand}
                                 autoExpandParent={true}
                                 onCheck={onCheck}
                                 checkedKeys={checkedKeys}
                                 onSelect={onSelect}
                                 selectedKeys={selectedKeys}
                                 treeData={treeData}
                                 style={{ paddingBottom: "15px", paddingTop: "15px" }}
                                 defaultExpandParent={true}
                              />

                           </div>

                        </SimpleBarReact>
                        </Form.Item>
                     </div>
                  </Col>
                  <Col xs={24} md={8} lg={8}>
                     <div className="homework-modal-panel">
                        <div className="homework-modal-section-header">
                           <span className="homework-modal-section-icon"><AntDIcons.FileTextOutlined /></span>
                           <div>
                              <span className="homework-modal-kicker">Content</span>
                              <h3>Description</h3>
                           </div>
                        </div>
                     {/* <Wysiwyg2
                        changeContentCallback={(e) => handleDescriptionChange(e)}
                        content={description}
                        height={190}
                        contentHeight={95}
                     /> */}
                     <WysiwygMathEditor
                        id={`homework-body-${user_id}`}
                        content={description}
                        changeContentCallback={(e) => handleDescriptionChange(e)}
                        height={230}
                        // contentHeight={230}
                        disabled={false}
                     />
                     {/* <Editor
                        apiKey={`${process.env.REACT_APP_TINY_MCE_API_KEY}`}
                        onInit={(evt, editor) => editorRef.current = editor}
                        onFocusOut={(e) => handleDescriptionChange(e.target.innerHTML)}
                        initialValue={description}
                        init={{
                           menubar: false,
                           height: 250,
                           statusbar: true,
                           plugins: [
                              'advlist autolink lists link image charmap print preview anchor',
                              'searchreplace visualblocks code',
                              'insertdatetime media table paste code help wordcount emoticons'
                           ],
                           toolbar: 'undo redo | formatselect | ' +
                              'bold italic backcolor | alignleft aligncenter ' +
                              'alignright alignjustify | bullist numlist outdent indent | ' +
                              'removeformat | emoticons | help',
                           content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}
                     /> */}
                     </div>
                  </Col>
                  <Col xs={24} md={8} lg={8}>
                     <div className="homework-modal-panel">
                        <div className="homework-modal-section-header">
                           <span className="homework-modal-section-icon"><AntDIcons.CloudUploadOutlined /></span>
                           <div>
                              <span className="homework-modal-kicker">Resources</span>
                              <h3>Attach Documents</h3>
                           </div>
                           <span className="homework-modal-count">{uploadFileList.length}</span>
                        </div>
                        <Form.Item name="attached_documents" label={<Text>Attach Document(s)</Text>}>
                        <SimpleBarReact className="homework-modal-scroll is-edit">
                           <StickyBox>
                              <Upload
                                 style={{ display: "block" }}
                                 maxCount={3}
                                 multiple
                                 {...upload_props}
                                 listType="picture"
                                 className="upload-list-inline"
                                 accept=".doc,.docx,application/msword,
                                application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                                .xls,.xlsx,.ppt,.pptx,.ppsx,
                                .png,.jpg,.pdf,.bmp"
                              >
                                 <Button size='middle' shape='round' icon={<AntDIcons.CloudUploadOutlined />} block>Select File</Button>
                              </Upload>
                           </StickyBox>

                        </SimpleBarReact>
                        </Form.Item>
                     </div>
                  </Col>
               </Row>
            </Form>
            :
            <div className='homework-modal-loading'>
               <Spin size='large' tip="Loading, please wait..." />
            </div>
         }

         <Modal
            title="Document Preview"
            className="homework-assignment-modal homework-document-preview-modal"
            centered
            destroyOnClose={true}
            open={previewModalVisible}
            width="80%"
            footer={[
               <Button key="close" shape="round" onClick={() => handleClosePreview()}>
                  Close
               </Button>
            ]}
            onCancel={() => handleClosePreview()}
         >
            <div className='modal-document-viewer homework-document-preview-viewer'>
               <DocumentViewer
                  document={previewDocument}
                  documentname={previewDocumentName}
                  dvheight="calc(100dvh - 220px)"
                  ismodal={true}
               />
            </div>
         </Modal>
      </>
   );
}

